export default {
  Nav: {
    Home: 'Home',
    About: 'About',
    Game: 'Game',
    Joinus: 'Join Us',
    contactUs: 'Contact Us',
    secret: 'Policy',
    terms: 'Terms',
    safe: 'Account Safety',
  },
  Footer: {
    cont: "Copyright {'@'} 2023 HONGYU NETWORK TECHNOLOGY CO., LIMITED. All Rights Reserved.",
  },
  commencont: {
    Coming: 'Coming soon',
  },
  contactus: {
    address:
      '2/F, Phase I, Playmates Factory Building,1 Tin Hau Road, Tuen Mun District,New Territories,Hong Kong,China',
    title: 'HONGYU NETWORK TECHNOLOGY CO., LIMITED',
  },
  Aboutus: {
    about1:
      'Founded in 2023, Hongyu Network Technology Co., Ltd. is an Internet company specializing in the field of interactive entertainment. The company focuses on original games R&D, and will continue to improve its products and services, providing new interactive entertainment experience to global players.',
    // about2: 'Our company has industry-leading R&D and operation teams, specializing in games and animations. Mutliple high quality games are in development. We will stay commited to offering professional services for global users.',
    // about3: 'In the future, YouLe Fun will continue to develop the absolute best products possible, ones that exceed users’ expectations and bring fun, exciting entertainment and high-quality services to players everywhere.',
  },
  title: {
    title: 'HONG YU GAMES',
    Keywords:
      'HONG YU GAMES,mobile games,netgame,android,apple game,ios game,publisher,overseas game,hong kong games,google play games,appstore,download,install,Samsung,huawei,oppo,vivo,meta,vr game, war game,strategy game, revenge, war strategy, free games, online games, mobile app, arabic game,RTS, MMO,world game',
    Description: 'A mobile game develop and publisher。',
  },
  Secret: {
    src: '/static/policy-en.html',
  },
  Terms: {
    src: '/static/terms-en.html',
  },
  Account: {
    line1:
      'If you log in through Google or Facebook, please create an account name and password in Account Management.',
    line2:
      'Reminder: If you log in through Google or Facebook, please create your account name and password in Account Management.',
    line3:
      "Please send your UID, account name and password to xinshengcrm{'@'}gmail.com",
    form1: 'please input your uid',
    form2: 'please input your account',
    form3: 'please input your password',
    btn1: 'Delete Account',
    btn2: 'Delete data',
    btn3: 'Cancel',
    btn4: 'Confirm',
  },
  Booking: {
    success: 'Booking successful',
  },
  Game: {
    list: [
      {
        name: 'DeadFront',
        introduction:
          'DeadFront is a unique idle card RPG that combines hero collection, SLG base building, tower defense, and faction warfare into one deep strategy experience. Recruit legendary heroes, fortify your shelter, and lead your alliance to conquer the wasteland. Progress never stops — your survivors keep fighting and looting even when you are away.',
        facebook: 'https://www.facebook.com/profile.php?id=61589437860611',
        discord: 'https://discord.gg/5VdNtF2aBz',
        ios: 'https://apps.apple.com/us/app/deadfront-zombie-survival-rpg/id6781503453',
        android:
          'https://play.google.com/store/apps/details?id=com.hongyu.deadfront',
      },
      {
        name: 'Emberbone: Blood and Ash',
        introduction:
          'A massive 3D MMORPG in a dark fantasy open world where bones litter battlefields and fire has faded to ash. Explore a seamless frontier, summon ancient spirits, forge your legend, and fight for Sabuk in this epic online RPG.',
        facebook: 'https://www.facebook.com/profile.php?id=61591302717172',
        discord: 'https://discord.gg/XCqbcrU5TX',
        ios: '',
        android: '',
      },
    ],
  },
}
